import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { detectOldIE } from '@Services/BrowserHelper';
import HeatmapHelperService from '@Pages/Heatmap/HeatmapHelperService';
import BaseHeaderCell from '@Pages/Heatmap/HeatmapTable/Header/BaseHeaderCell';
import { MIN_STRUCTURE_LABEL_SIZE } from '@Pages/Heatmap/HeatmapTable/constants';

export const MAX_WIDTH_IE = 140;

function ColumnHeaderCell({
  index,
  visibleIndex,
  cell,
  height,
  width,
  isRow,
  isVertical,
  selectHeaderItem,
  selectedHeaderItems,
  hoveredItem,
  handleHover,
  showStructure,
}) {
  const maxWidthVertical = detectOldIE() && width > MAX_WIDTH_IE ? MAX_WIDTH_IE : width; // for IE11
  const labelStyle = {
    ...(isVertical
      ? {
          width: `calc(${height}px - 4rem)`, // -2rem (heatmap__header__sorting) - 2rem (heatmap__header__density)
          lineHeight: `calc(${maxWidthVertical}px - 0.5rem)`, // for centering text
        }
      : {
          width: `calc(${width}px - 2rem)`, // -2rem for padding
          alignItems: 'center',
        }),
  };

  return (
    <BaseHeaderCell
      index={index}
      cell={cell}
      isRow={isRow}
      selectHeaderItem={selectHeaderItem}
      showStructure={showStructure}
      handleHover={handleHover}
      hoveredItem={hoveredItem}
      mainStyle={{
        left: `${width * visibleIndex}px`,
        width: `${width}px`,
        borderLeft: selectedHeaderItems.indexOf(index) !== -1 && HeatmapHelperService.getCellBorder(selectedHeaderItems, index, true),
        borderRight: selectedHeaderItems.indexOf(index) !== -1 && HeatmapHelperService.getCellBorder(selectedHeaderItems, index, false),
      }}
      structureWrapperClassName="heatmap__header__structure-cols-wrapper"
      structureClassName="heatmap__header__structure heatmap__header__substance"
      labelClassName="heatmap__header__substance"
      mainClassName={classnames({
        heatmap__header: true,
        'heatmap__header--vertical': isVertical && !showStructure,
        'heatmap__header--horizontal': !isVertical,
        'heatmap__header--vertical-selected': selectedHeaderItems.indexOf(index) !== -1,
        'heatmap__header--vertical-hovered': hoveredItem && hoveredItem.index === index && hoveredItem.showBorder,
      })}
      labelStyle={labelStyle}
      structureLabelStyle={{
        width: `${width - 10}px`,
        display: height > MIN_STRUCTURE_LABEL_SIZE ? 'block' : 'none',
      }}
    />
  );
}

ColumnHeaderCell.propTypes = {
  index: PropTypes.number,
  visibleIndex: PropTypes.number,
  cell: PropTypes.object,
  selectHeaderItem: PropTypes.func,
  selectedHeaderItems: PropTypes.array.isRequired,
  hoveredItem: PropTypes.object,
  showStructure: PropTypes.bool,
  handleHover: PropTypes.func,
  isRow: PropTypes.bool,
  isVertical: PropTypes.bool,
  height: PropTypes.number,
  width: PropTypes.number,
};

export default ColumnHeaderCell;
